import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Home from './components/Pages/Home/Home/Home';
import Services from './components/Pages/Services/Services';
import AppBar from './components/Pages/Home/Navbar/AppBar';
import Register from './components/Pages/Register/Register';
import Login from './components/Pages/Login/Login';
import AuthProvider from './context/AuthProvider';
import Footer from './components/Pages/Home/Footer/Footer';
import Doctors from './components/Pages/Doctors/Doctors';
import Gallery from './components/Pages/Gallery/Gallery';
import NotFound from './components/NotFound/NotFound';
import ServiceDetails from './components/ServiceDetails/ServiceDetails';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';



function App() {
  return (
    <div className="App">
    <AuthProvider>
    <Router>
    <AppBar></AppBar>
       <Switch>
         <Route exact path="/">
           <Home></Home>
         </Route>
         <Route path="/home">
           <Home></Home>
         </Route>
         <Route path="/services">
           <Services></Services>
         </Route>
         <Route path="/register">
           <Register></Register>
         </Route>
         <Route path="/doctors">
         <Doctors></Doctors>
         </Route>
         <Route path="/gallery">
         <Gallery></Gallery>
         </Route>
         <Route path="/login">
         <Login></Login>
         </Route>
         <PrivateRoute path="/details/:detailsId">
         <ServiceDetails></ServiceDetails>
         </PrivateRoute>
         <Route path="*">
         <NotFound></NotFound>
         </Route>
       </Switch>
       <Footer></Footer>
     </Router>
    </AuthProvider>
    </div>
  );
}

export default App;
